import styled from "styled-components";

export const InvoiceWrapper = styled.div`
   /* padding: 20px 30px;
    background: #FFFFFF;

    border: 1.5px solid rgba(211, 211, 211, 0.5);
    border-radius: 15px; */
`

export const TopHeading = styled.div`
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 10px;
    align-items: flex-start;
    padding: 16px 0;
    .icon-text-wrapper {
      display: flex;
      align-items: center;
      gap: 10px;
    }
    /* > div {
        display: grid;
        gap: 5px;
    } */
     .order-invoice-icon {
    width: clamp(28px,1.979vw,38px);
    height: clamp(28px,1.979vw,38px);
}
    h4 {
      font-size: clamp(12px,0.833vw,16px);
      letter-spacing: 0.005em;
      color: #005586;
      font-family: "latobold";
      margin: clamp(3px,0.26vw,5px) 0;
    }
    p {
        font-size: 16px;
        line-height: 19px;
        letter-spacing: 0.005em;
        color: rgba(17, 17, 17, 0.8);
        margin: 5px 0;

    }
`

export const Heading = styled.div`
    display: flex;
    justify-content: end;
    gap: 2px;
    /* margin-bottom: 25px; */
    .react-select__control {
        border: 1px solid #e0e0e0;
        border-radius: 6px;
        min-height: 44px;
    }
    /* .react-select__value-container {
        padding-left: 18px;
        padding-right: 10px;
    } */
    .react-select__single-value {
        font-size: 14px;

    }
    .react-select__option {
        font-size: 14px;
        padding-left: 18px;

    }
    >div{
        > h4
        {
            line-height: 40px;
        }
    }
    
`

export const SearchWrapper = styled.div`
  display: flex;
  position: relative;
  overflow: auto;
  min-width: 200px;
  width: 200px;
  height: 44px;
  &.responsive {
    height: clamp(38px,2.292vw,44px);
    input {
      padding: 4px clamp(10px,0.781vw,15px) 4px clamp(33px,2.292vw,44px);
      font-size: clamp(10px,0.729vw,14px);
    }
    .search-icon {
    position: absolute;
    transform: translate(clamp(14px,0.938vw,18px), clamp(12px,0.833vw,16px));
    height: clamp(10px,0.677vw,13px);
    width: clamp(10px,0.677vw,13px);
  }
  }
  .rbt-menu {
    display: none !important;
  }
  input {
    background: #ffffff;
    border-radius: 6px;
    border: solid 1px #DADADF;
    padding: 4px 15px 4px 45px;
    width: 100%;
    font-size: 14px;
    font-family: "latoregular";

    ::-webkit-input-placeholder {
      /* Edge */
      color: #A0A7B8;
      font-family: "latoregular";

    }

    :-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: #A0A7B8;
      font-family: "latoregular";

    }

    ::placeholder {
      color: #A0A7B8;
      font-family: "latoregular";

    }
  }
  .search-icon {
    position: absolute;
    transform: translate(18px, 16px);
  }
`;

export const RightSection = styled.div`
  display: flex;
  align-items: flex-start;
  gap:15px 10px;
  flex-wrap: wrap;
  justify-content: flex-end;
  .all-invoice-date-picker {
    .MuiFormHelperText-root.Mui-error {
      position: unset;
    }
    
  }
  .select__value-container {
    padding: 4px 8px;
    min-height: clamp(33px,2.292vw,44px);
    max-height: 104px;
    overflow: auto;
  }
  .select__multi-value__label {
    font-size: clamp(10px,0.729vw,14px);
  }
  .react-select__value-container {
    height: 100%;
  }
    `